import classNames from "classnames";
import React from "react";
import NotFoundText from "@/components/NotFoundText";
import Button from "@/components/Elements/Button";
import AnimateHeight from "react-animate-height";
import GridViewItem from "../GridViewItem/Index";
import { AuctionItemListContext } from "../AuctionListItems";

const GridView = () => {
  const {
    auctionItems,
    auctionItemBids,
    fetchBids,
    totalItems,
    serverTime,
    isLoading,
    isFetching,
    error,
    maxItems,
    animateDuration,
    firstVisibleId,
    clearFilter,
    showResetFilterOnNotFound,
    visibleItemsData,
  } = React.useContext(AuctionItemListContext);

  return (
    <div className="flex flex-col w-full">
      <div
        className={classNames(
          "flex flex-col space-y-6 [&>:not(.is-hidden):first-child]:!mt-0",
          {
            "opacity-80": isFetching,
          }
        )}
      >
        {error && !auctionItems && serverTime && (
          <NotFoundText
            title="Hittade inga rop"
            description="Något gick fel när vi försökte att hämta ropen. Försök igen senare."
          />
        )}

        {!isLoading &&
          auctionItems &&
          typeof visibleItemsData === "number" &&
          visibleItemsData < 1 && (
            <NotFoundText
              title="Hittade inga rop"
              description="Inga rop finns att visa för valda inställningar, pröva att ändra dina filter."
              buttonElement={
                showResetFilterOnNotFound && (
                  <Button
                    bgColor="transparent"
                    textColor="blue"
                    borderColor="blue"
                    onClick={clearFilter}
                  >
                    Återställ filter
                  </Button>
                )
              }
            />
          )}

        {!!auctionItems &&
          !isLoading &&
          serverTime &&
          auctionItems.map((item: any, index: any) => {
            if (maxItems && index >= maxItems) return null;

            const bidsData = auctionItemBids
              ? auctionItemBids?.find(
                  (itemData: any) =>
                    String(itemData?.itemId) === String(item.itemId)
                )
              : [];

            const isHidden = item?.isHidden;

            return (
              <AnimateHeight
                key={item.itemId}
                duration={animateDuration}
                height={isHidden ? 0 : "auto"}
                animateOpacity
                className={classNames({
                  "!m-0 is-hidden": isHidden,
                  "!m-0": item.itemId === firstVisibleId,
                })}
              >
                <GridViewItem
                  item={item}
                  prefetchedBidsData={bidsData}
                  fetchBids={fetchBids}
                  totalItems={totalItems}
                  serverTime={serverTime}
                  isLoading={isLoading}
                  isFetching={isFetching}
                />
              </AnimateHeight>
            );
          })}
      </div>
    </div>
  );
};

export default GridView;
